/* eslint-disable */
import {
    BASIC_COMPOSITION_TYPE,
    FIXED_COMPOSITION_TYPE,
    GODIA_LOYALTY,
    ITEM_TYPE,
    OFFER_FIRST_TYPE,
} from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import { produce } from "immer";
import { v4 as uuid } from "uuid";
import { snapshot } from "valtio";

import { getDiscountRate } from "@components/OrderTaking/Helpers";
import {
    convertSalesModeValue,
    reOrderItemsByStepOrderAndParentUuid,
} from "@components/OrderTaking/Helpers/Commonfunction";
import { syncStore } from "@components/Synchronization/store";

const { selectedShopApp } = snapshot(syncStore);
const { machineIpAddress } = snapshot(syncStore);

const initialState = {
    middlwareOrder: {
        orderUuid: "",
        codeManager: "",
        nomManager: "",
        codeVendeur: "",
        nomOVendeur: "",
        nbClient: "",
        orderOrigine: "KIOSK",
        ipOrigine: machineIpAddress,
        numCommande: "",
        sourceOrderOrigine: "", // à verifier
        sourceOrderNumber: 0,
        destinationOrderOrigine: "",
        destinationTicketNumber: 0,
        horodatage: 0,
        tag: "",
        dateFiscale: 0,
        OrderId: 0,
        remiseGlobale: {},
        salesMode: "",
        totalttc: 0,
        deviseCode: "",
        deviseTaux: 1,
        deviseLibelle: "",
        lines: [],
        promo: { type: "cesar", usedCodes: [] },
        loyalty_payment: 0,
        reglements: [],
        complement: {
            //"modeinfo":{"type":1,"data":""}
            modeInfo: { type: "", data: { infoModeUuId: "", value: "" } },
            ///  modeReg: { type: "", data: "" },
            modeAuth: { type: "", data: "" },
        },
        clientPhoneNumber: "",
    },
};
let data = [];
let lineDiscount = {
    discountMontant: 0,
    discountTaux: 0,
    libelle: "",
};

export const middlwareOrderSlice = createSlice({
    name: "middlwareOrderSlice",
    initialState,
    reducers: {
        setMiddlwareOrder: (state, action) => {
            const { machineIpAddress } = snapshot(syncStore);
            clearMiddlwareOrder();
            console.log("store:", { machineIpAddress });
            data = [];
            const {
                order,
                selectedSaleModeValue,
                selectedAuthMode,
                chosenInformationMode,
                paymentModes,
                phoneNumber,
                loyaltyRewards,
                usedGifts,
                amountRatio,
            } = action.payload;

            console.log(
                `setMiddlwareOrder --- order before structure modification : ${JSON.stringify(
                    order
                )}`
            );

            //! to verify
            let discountRate = 0;
            let isOrderPromo = false;
            let promo = {
                type:
                    selectedShopApp.fidelityType === GODIA_LOYALTY
                        ? "godia"
                        : "cesar",
                usedCodes: [],
            };
            if (usedGifts.length > 0) {
                let totalOrderNet = order.orderItems.reduce(
                    (a, c) => a + c.quantity * c.price,
                    0
                );
                const promoProduct = order.orderItems.filter(
                    (product) => product.isPromo === true
                )[0];
                const discountItems = getDiscountRate(
                    totalOrderNet,
                    usedGifts[0].discountType,
                    usedGifts[0].discountValue,
                    promoProduct
                );
                discountRate = discountItems.discountRate;
                isOrderPromo = discountItems.isOrderPromo;
                promo.usedCodes = [{ ...usedGifts[0], discountRate }];
            }

            state.middlwareOrder.orderUuid = uuid();
            state.middlwareOrder.codeManager = 0;
            state.middlwareOrder.nomManager = "";
            state.middlwareOrder.codeVendeur = 0;
            state.middlwareOrder.nomOVendeur = "";

            state.middlwareOrder.ipOrigine = machineIpAddress;
            state.middlwareOrder.numCommande = 0;
            state.middlwareOrder.sourceOrderOrigine = "";
            state.middlwareOrder.sourceOrderNumber = 0;
            state.middlwareOrder.destinationOrderOrigine = "";
            state.middlwareOrder.destinationTicketNumber = 0;
            state.middlwareOrder.horodatage = Date.now();
            state.middlwareOrder.tag = "";
            state.middlwareOrder.dateFiscale = Date.now();
            state.middlwareOrder.OrderId = 0;
            state.middlwareOrder.remiseGlobale = {};
            state.middlwareOrder.salesMode = convertSalesModeValue(
                selectedSaleModeValue
            );
            /**  must be calculated with this formula
             * totalttc = Somme des montantTotalTTC - (Somme des montantTotalTTC*(remiseGlobale.discountTaux/100))  */

            state.middlwareOrder.deviseCode = "euro";
            state.middlwareOrder.deviseTaux = 0;
            state.middlwareOrder.deviseLibelle = "euro";

            // state.middlwareOrder.complement.modeInfo.type =
            //     selectedInformationMode;

            // state.middlwareOrder.complement.modeReg.type =
            //     selectedRegulationModeValue;

            state.middlwareOrder.complement.modeInfo = chosenInformationMode;
            state.middlwareOrder.reglements = paymentModes;
            state.middlwareOrder.clientPhoneNumber = phoneNumber;

            state.middlwareOrder.complement.modeAuth.type = selectedAuthMode;

            order.orderItems
                .reduce((prev, currProd) => {
                    if (currProd.offer.isEnabled && currProd.quantity > 1) {
                        const separatedProducts = [];

                        for (let i = 0; i < currProd.quantity; i++) {
                            const itemData = {
                                ...currProd,
                                quantity: 1,
                                iuudOrder:
                                    i === 0 ? currProd.iuudOrder : uuid(),
                            };
                            separatedProducts.push(itemData);
                        }
                        return [...prev, ...separatedProducts];
                    }
                    return [...prev, currProd];
                }, [])
                .forEach((item) => {
                    if (Object.keys(item?.shopCart).length === 0) {
                        state.middlwareOrder.lines.push({
                            lineUuid: item.iuudOrder,
                            isReward: item.isReward ?? false,
                            orderUuid: state.middlwareOrder.orderUuid,
                            horodatage: item.date,
                            codeManager: state.middlwareOrder.codeManager,
                            nomManager: state.middlwareOrder.nomManager,
                            codeVendeur: state.middlwareOrder.codeVendeur,
                            nomVendeur: state.middlwareOrder.nomOVendeur,
                            reference: item.reference,
                            itemUuid: item.iuud,
                            typeLigne: "ARTICLE",
                            designation: item.designation,
                            prix: item.price,
                            //prixUnitaireCarte: item.price,
                            qte: item.quantity,
                            poids: 1, // à verifier
                            unite: item.unity, //"PIECE", // à verifier
                            libFamille: item.categoryTitle,
                            libSousFamille: item.subcategoryTitle, // à ajouter
                            numFamille: item.parent, // à ajouter
                            numSousFamille: 0, // à ajouter
                            libelleTVA: "", // à verifier
                            numTVA: 0, // à verifier
                            tauxTVA: item.tva !== undefined ? item.tva : 0, // à verifier
                            ipOrigine: machineIpAddress,
                            orderOrigine: "", // à ajouter
                            lineDiscount: lineDiscount,
                            montantTotalTTC:
                                item.price * item.quantity -
                                item.price *
                                    item.quantity *
                                    (lineDiscount.discountTaux / 100), // à verifier
                            montantTotalHT: 0, // à verifier
                            tag: "",
                            pointFid: item.fidelity,
                            ModifierUuid: "",
                            parentLineUuid: "",
                            stepTitle: item.stepTitle ? item.stepTitle : "",
                            selectedOptions: item.selectedOptions,
                            selectedOptionsUuid: item.selectedOptionsUuid,
                            selectedIndexOptions: item.selectedIndexOptions,
                            comment:
                                item?.comment !== undefined
                                    ? item?.comment
                                    : "",
                            isSubProduct: item.isSubProduct,
                            isOfferParent: item.isOfferParent,
                            isOfferChild: item.isOfferChild,
                            discountRate: getDiscountRateValue(
                                item,
                                discountRate,
                                isOrderPromo
                            ),
                            isPromo: item.isPromo ?? false,
                        });
                    } else {
                        let orderInfo = {
                            orderUuid: state.middlwareOrder.orderUuid,
                            codeManager: state.middlwareOrder.codeManager,
                            nomManager: state.middlwareOrder.nomManager,
                            codeVendeur: state.middlwareOrder.codeVendeur,
                            nomVendeur: state.middlwareOrder.nomOVendeur,
                        };

                        if (
                            item.isOfferParent &&
                            item.offer.type === OFFER_FIRST_TYPE
                        ) {
                            item = produce(item, (draft) => {
                                if (draft.isOfferParent) {
                                    const shopCartValues = Object.values(
                                        draft.shopCart
                                    );
                                    draft.price = 0;
                                    const compositions =
                                        shopCartValues[0]?.compositions;

                                    if (compositions) {
                                        Object.keys(compositions).forEach(
                                            (key) => {
                                                const subItem =
                                                    compositions[key];
                                                if (subItem?.price > 0) {
                                                    draft.price +=
                                                        subItem.price;
                                                    subItem.price = 0;
                                                }
                                            }
                                        );
                                    }
                                }
                            });
                        }
                        state.middlwareOrder.lines.push({
                            lineUuid: item.iuudOrder,
                            isReward: item.isReward ?? false,
                            orderUuid: state.middlwareOrder.orderUuid,
                            horodatage: item.date,
                            codeManager: state.middlwareOrder.codeManager,
                            nomManager: state.middlwareOrder.nomManager,
                            codeVendeur: state.middlwareOrder.codeVendeur,
                            nomVendeur: state.middlwareOrder.nomOVendeur,
                            reference: item.reference,
                            itemUuid: item.iuud,
                            typeLigne:
                                item.haveWorkflow && !item.isOfferParent
                                    ? "MENU"
                                    : "Article",
                            designation: item.designation,
                            prix:
                                item.offer.type === OFFER_FIRST_TYPE &&
                                (item.isOfferParent || item.isOfferChild)
                                    ? item.price
                                    : item.defaultPrice,
                            // prixUnitaireCarte: item.price,
                            qte: item.quantity,
                            poids: 1, // à verifier
                            unite: item.unity, // à verifier
                            libFamille: item.categoryTitle,
                            libSousFamille: item.subcategoryTitle,
                            numFamille: item.parent, // à ajouter
                            numSousFamille: 0, // à ajouter
                            libelleTVA: "", // à verifier
                            numTVA: 0, // à verifier
                            tauxTVA: item.tva !== undefined ? item.tva : 0, // to be removed
                            ipOrigine: machineIpAddress,
                            orderOrigine: "", // à ajouter
                            lineDiscount: lineDiscount,
                            montantTotalTTC:
                                item.defaultPrice * item.quantity -
                                item.defaultPrice *
                                    item.quantity *
                                    (lineDiscount.discountTaux / 100), // à verifier
                            montantTotalHT: 0, // à verifier
                            tag: "",
                            pointFid: item.fidelity,
                            ModifierUuid: "",
                            parentLineUuid: "",
                            stepTitle: item.stepTitle ? item.stepTitle : "",
                            selectedOptions: item.selectedOptions,
                            selectedOptionsUuid: item.selectedOptionsUuid,
                            selectedIndexOptions: item.selectedIndexOptions,
                            comment:
                                item?.comment !== undefined
                                    ? item?.comment
                                    : "",
                            isSubProduct: item.isSubProduct,
                            discountRate: getDiscountRateValue(
                                item,
                                discountRate,
                                isOrderPromo
                            ),
                            isPromo: item.isPromo ?? false,
                            isOfferParent: item.isOfferParent,
                            isOfferChild: item.isOfferChild,
                        });

                        fillMiddlwareOrder(
                            item.shopCart,
                            item.iuudOrder,
                            orderInfo,
                            discountRate,
                            isOrderPromo
                        );

                        state.middlwareOrder.lines = [
                            ...state.middlwareOrder.lines,
                            ...data,
                        ];
                    }
                });
            const newLines = reOrderItemsByStepOrderAndParentUuid(
                [...new Set(state.middlwareOrder.lines)].sort((a, b) => {
                    return a.stepRank - b.stepRank;
                })
            );

            let linesTotalPrice = 0;
            newLines.forEach((line) => {
                linesTotalPrice += line.prix * line.qte;
            });
            if (linesTotalPrice != order.totalPrice) {
                console.error(
                    `ERRRROORR: Total price different of total order lines price with totalPrice: ${order.totalPrice} and linesTotalPrice: ${linesTotalPrice}`
                );
            }
            console.log(
                `setMiddlwareOrder --- order lines after structure modification : ${JSON.stringify(
                    newLines
                )}`
            );

            state.middlwareOrder.lines = newLines;

            // add rewards to put command order
            const finalRewardList = [];
            let totalRewardsPoints = 0;
            const rewardsRef = state.middlwareOrder.lines
                .filter((line) => line.isReward)
                .map((line) => line.reference);

            loyaltyRewards.forEach((item) => {
                const rewardList = item.rewardList.filter((reward) =>
                    rewardsRef.includes(reward.reference)
                );
                rewardList.forEach((reward) => {
                    totalRewardsPoints =
                        totalRewardsPoints + Number(item.loyalty_points);
                    finalRewardList.push({
                        program_id: item.program_id,
                        reward_name: item.reward_name,
                        reward_item_reference: reward.reference,
                        loyalty_points: item.loyalty_points,
                    });
                });
            });
            state.middlwareOrder.rewards = [...finalRewardList];
            state.middlwareOrder.loyalty_payment = totalRewardsPoints;
            state.middlwareOrder.promo = promo;

            state.middlwareOrder.totalttc = order.totalPrice;
            console.log(
                `setMiddlwareOrder --- order Totale Price after structure modification : ${state.middlwareOrder.totalttc}`
            );
        },
        clearMiddlwareOrder: (state) => {
            state.middlwareOrder = {
                orderUuid: "",
                codeManager: "",
                nomManager: "",
                codeVendeur: "",
                nomOVendeur: "",
                nbClient: "",
                orderOrigine: "KIOSK",
                ipOrigine: "",
                numCommande: "",
                sourceOrderOrigine: "",
                sourceOrderNumber: 0,
                destinationOrderOrigine: "",
                destinationTicketNumber: 0,
                horodatage: 0,
                tag: "",
                dateFiscale: 0,
                OrderId: 0,
                remiseGlobale: {},
                salesMode: "",
                totalttc: 0,
                deviseCode: "",
                deviseTaux: 1,
                deviseLibelle: "",
                lines: [],
                reglements: [],
                complement: {
                    modeInfo: {
                        type: "",
                        data: { infoModeUuId: "", value: "" },
                    },
                    //      modeReg: { type: "", data: "" },
                    modeAuth: { type: "", data: "" },
                },
                clientPhoneNumber: "",
            };
        },
    },
});

function fillMiddlwareOrder(
    compoundItem,
    parent,
    orderInfo,
    discountRate,
    isOrderPromo
) {
    const { machineIpAddress } = snapshot(syncStore);
    let compoundLines = [];

    Object.values(compoundItem).forEach((item) => {
        if (item?.compositions !== undefined) {
            if (item.name) {
                let localLineIuud = uuid();

                compoundLines.push({
                    lineUuid: localLineIuud,
                    orderUuid: orderInfo.orderUuid,
                    horodatage: item.date,
                    codeManager: orderInfo.codeManager,
                    nomManager: orderInfo.nomManager,
                    codeVendeur: orderInfo.codeVendeur,
                    nomVendeur: orderInfo.nomVendeur,
                    reference: item.reference,
                    itemUuid: item.iuud,
                    typeLigne: item.isOfferParent ? "Article" : "MENU", //  typeLigne: item.haveWorkflow ? "MENU" : "Article",
                    designation: item.designation,
                    prix: item.price,
                    //prixUnitaireCarte: item.price,
                    qte: item.quantity,
                    poids: 0,
                    unite: item.unity, //"PIECE",
                    libFamille: item.categoryTitle,
                    libSousFamille: item.subcategoryTitle,
                    numFamille: item.parent,
                    numSousFamille: 0,
                    libelleTVA: "",
                    numTVA: 0,
                    tauxTVA: item.tva !== undefined ? item.tva : 0,
                    ipOrigine: machineIpAddress,
                    orderOrigine: "",
                    lineDiscount: lineDiscount,
                    montantTotalTTC:
                        item.price * item.quantity -
                        item.price *
                            item.quantity *
                            (lineDiscount.discountTaux / 100),
                    montantTotalHT: 0,
                    tag: "",
                    pointFid: item.fidelity,
                    ModifierUuid: "",
                    parentLineUuid: item.isOfferChild ? "" : parent,
                    stepTitle: item.stepTitle,
                    stepRank: item?.stepRank,
                    comment: item?.comment !== undefined ? item?.comment : "",
                    isSubProduct: item.isSubProduct,
                    isOfferParent: item.isOfferParent,
                    isOfferChild: item.isOfferChild,
                    discountRate: getDiscountRateValue(
                        item,
                        discountRate,
                        isOrderPromo
                    ),
                    isPromo: item.isPromo ?? false,
                });

                parent = localLineIuud;
            }

            Object.entries(item?.compositions).forEach(
                ([
                    key,
                    {
                        compositions,
                        name,
                        designation,
                        quantity,
                        price,
                        reference,
                        categoryTitle,
                        categoryParent,
                        iuud,
                        fidelity,
                        tva,
                        path,
                        date,
                        stepTitle,
                        selectedOptions,
                        selectedOptionsUuid,
                        subcategoryTitle,
                        stepRank,
                        comment,
                        isSubProduct,
                        isOfferParent,
                        isOfferChild,
                        type,
                        unity,
                        isPromo,
                    },
                ]) => {
                    if (compositions === undefined) {
                        let localLineIuud = uuid();

                        compoundLines.push({
                            lineUuid: localLineIuud,
                            orderUuid: orderInfo.orderUuid,
                            horodatage: date,
                            codeManager: orderInfo.codeManager,
                            nomManager: orderInfo.nomManager,
                            codeVendeur: orderInfo.codeVendeur,
                            nomVendeur: orderInfo.nomVendeur,
                            reference: reference,
                            itemUuid: iuud,
                            typeLigne:
                                type === ITEM_TYPE
                                    ? "Article"
                                    : type === FIXED_COMPOSITION_TYPE
                                    ? type
                                    : item.type,
                            designation,
                            prix:
                                path[path.length - 3].name ===
                                BASIC_COMPOSITION_TYPE
                                    ? 0
                                    : price,
                            //prixUnitaireCarte: price,
                            qte: quantity,
                            poids: 0,
                            unite: unity, //"PIECE",
                            libFamille: categoryTitle,

                            libSousFamille: subcategoryTitle,
                            numFamille: categoryParent,
                            numSousFamille: 0,
                            libelleTVA: "",
                            numTVA: 0,
                            tauxTVA: tva !== undefined ? tva : 0,
                            ipOrigine: machineIpAddress,
                            orderOrigine: "",
                            lineDiscount: lineDiscount,
                            montantTotalTTC:
                                price * quantity -
                                price *
                                    quantity *
                                    (lineDiscount.discountTaux / 100),
                            montantTotalHT: 0,
                            tag: "",
                            pointFid: fidelity,
                            ModifierUuid: "",
                            parentLineUuid: isOfferChild ? "" : parent,
                            stepTitle,
                            selectedOptions,
                            selectedOptionsUuid,
                            stepRank,
                            comment,
                            isSubProduct,
                            isOfferParent,
                            isOfferChild,
                            discountRate: getDiscountRateValue(
                                item,
                                discountRate,
                                isOrderPromo
                            ),
                            isPromo,
                        });
                    } else {
                        let localParent = parent;
                        if (name) {
                            let localLineIuud = uuid();
                            compoundLines.push({
                                lineUuid: localLineIuud,
                                orderUuid: orderInfo.orderUuid,
                                horodatage: date,
                                codeManager: orderInfo.codeManager,
                                nomManager: orderInfo.nomManager,
                                codeVendeur: orderInfo.codeVendeur,
                                nomVendeur: orderInfo.nomVendeur,
                                reference: reference,
                                itemUuid: iuud,
                                typeLigne: isOfferParent ? "Article" : "MENU", //  typeLigne: item.haveWorkflow ? "MENU" : "Article",
                                designation,
                                prix: price,
                                //prixUnitaireCarte: price,
                                qte: quantity,
                                poids: 0,
                                unite: unity, //"PIECE",
                                libFamille: categoryTitle,
                                libSousFamille: subcategoryTitle,
                                numFamille: categoryParent,
                                numSousFamille: 0,
                                libelleTVA: "",
                                numTVA: 0,
                                tauxTVA: tva !== undefined ? tva : 0,
                                ipOrigine: machineIpAddress,
                                orderOrigine: "",
                                lineDiscount: lineDiscount,
                                montantTotalTTC:
                                    price * quantity -
                                    price *
                                        quantity *
                                        (lineDiscount.discountTaux / 100),
                                montantTotalHT: 0,
                                tag: "",
                                pointFid: fidelity,
                                ModifierUuid: "",
                                parentLineUuid: isOfferChild ? "" : parent,
                                stepTitle,
                                selectedOptions,
                                selectedOptionsUuid,
                                stepRank,
                                comment,
                                isSubProduct,
                                discountRate: getDiscountRateValue(
                                    item,
                                    discountRate,
                                    isOrderPromo
                                ),
                                isPromo,
                                isOfferParent,
                                isOfferChild,
                            });
                            localParent = localLineIuud;
                        }
                        fillMiddlwareOrder(
                            compositions,
                            localParent,
                            orderInfo,
                            discountRate,
                            isOrderPromo
                        );
                    }
                }
            );
        } else {
            let localLineIuud = uuid();

            compoundLines.push({
                lineUuid: localLineIuud,
                orderUuid: orderInfo.orderUuid,
                horodatage: item.date,
                codeManager: orderInfo.codeManager,
                nomManager: orderInfo.nomManager,
                codeVendeur: orderInfo.codeVendeur,
                nomVendeur: orderInfo.nomVendeur,
                reference: item.reference,
                itemUuid: item.iuud,
                typeLigne:
                    item.path[item.path.length - 3].name ===
                    BASIC_COMPOSITION_TYPE
                        ? "COMPOSANT DE BASE"
                        : "Article",
                designation: item.designation,
                prix:
                    item.path[item.path.length - 3].name ===
                    BASIC_COMPOSITION_TYPE
                        ? 0
                        : item.price,
                //prixUnitaireCarte: item.price,
                qte: item.quantity,
                poids: 0,
                unite: item.unity,
                libFamille: item.categoryTitle,
                libSousFamille: item.subcategoryTitle,
                numFamille: item.parent,
                numSousFamille: 0,
                libelleTVA: "",
                numTVA: 0,
                tauxTVA: item.tva !== undefined ? item.tva : 0,
                ipOrigine: machineIpAddress,
                orderOrigine: "",
                lineDiscount: lineDiscount,
                montantTotalTTC:
                    item.price * item.quantity -
                    item.price *
                        item.quantity *
                        (lineDiscount.discountTaux / 100),
                montantTotalHT: 0,
                tag: "",
                pointFid: item.fidelity,
                ModifierUuid: "",
                parentLineUuid: item.isOfferChild ? "" : parent,
                comment: item?.comment !== undefined ? item?.comment : "",
                isSubProduct: item.isSubProduct,
                isOfferParent: item.isOfferParent,
                isOfferChild: item.isOfferChild,
                stepTitle: item.stepTitle,
                discountRate: getDiscountRateValue(
                    item,
                    discountRate,
                    isOrderPromo
                ),
                isPromo: item.isPromo ?? false,
            });
        }
    });
    data = [...data, ...compoundLines];
    return compoundLines;
}

function getDiscountRateValue(item, discountRate, isOrderPromo) {
    if (item.isReward) {
        return 100;
    }

    if (item.isPromo || isOrderPromo) {
        return discountRate;
    }

    return 0;
}

export const {
    setMiddlwareOrder,
    clearMiddlwareOrder,
    setMiddlwareOrderRewards,
} = middlwareOrderSlice.actions;

export default middlwareOrderSlice.reducer;
